import { __rest } from "tslib";
import React from 'react';
import { utils, defaultOptions } from 'pro-gallery-lib';
import ProGallery from './proGallery/proGallery.js';
import { ViewModeWrapperHOC } from './proGallery/viewModeWrapper.js';
class GalleryRenderer extends React.Component {
    render() {
        const _a = this.props, { id, options, eventsListener, customComponents } = _a, otherProps = __rest(_a, ["id", "options", "eventsListener", "customComponents"]);
        const _eventsListener = (eventName, eventData) => typeof eventsListener === 'function' && eventsListener(eventName, eventData);
        const _options = Object.assign(Object.assign({}, defaultOptions), options); //TODOVER3 can we remove the default options?? blueprints should take care of it
        const galleryRendererProps = Object.assign(Object.assign({}, otherProps), { options: _options, eventsListener: _eventsListener, id: id || 'default-dom-id', customComponents: customComponents || {} });
        utils.logPlaygroundLink(galleryRendererProps.options);
        if (galleryRendererProps.options &&
            galleryRendererProps.items &&
            galleryRendererProps.container &&
            galleryRendererProps.structure) {
            return React.createElement(ProGallery, Object.assign({}, galleryRendererProps));
        }
        else {
            return null;
        }
    }
}
export default ViewModeWrapperHOC(GalleryRenderer);
/* eslint-enable prettier/prettier */
//# sourceMappingURL=rendererIndex.js.map